import Compressor from 'compressorjs'

export const imgCompressor = async file => {
  return new Promise(resolve => {
    new Compressor(file, {
      quality: 0.92,
      success(result) {
        resolve(result)
      },
    })
  })
}

export default imgCompressor
